import { ColDef } from 'ag-grid-community'
import { AssetConcentrationReportEntry } from 'api/rtk-api'
import { AssetNameCell, CurrencyCell, Table } from 'components/core-v2'
import { displayPercentage } from 'utilities/number'

const cellStyle = params => {
  if (!params.node.data.assetClass) {
    return { background: 'var(--White90)' }
  }
}

const COLUMN_DEFS: ColDef[] = [
  {
    headerName: 'Fund manager / Asset',
    field: 'name',
    minWidth: 290,
    cellRenderer: params => {
      if (!params.data.assetClass) {
        return params.value
      }
      return AssetNameCell(params)
    },
    flex: 0.2,
    cellStyle
  },
  {
    headerName: 'Class',
    field: 'assetClass',
    minWidth: 290,
    flex: 0.2,
    cellStyle
  },
  {
    headerName: 'AUM(R)',
    field: 'aum',
    minWidth: 190,
    flex: 0.1,
    cellRenderer: CurrencyCell({
      currencyFieldName: 'currency',
      fieldName: 'aum',
      variant: 'full'
    }),
    cellStyle
  },
  {
    headerName: 'At risk',
    field: 'amountInvestedWithGapRisk',
    minWidth: 190,
    flex: 0.1,
    cellRenderer: params => {
      if (params.context.viewAsValueOrPercentage === 'percentage') {
        if (params.value === Infinity) return 'No AUM available'
        return displayPercentage(params.value, 2)
      }
      return CurrencyCell({
        currencyFieldName: 'currency',
        fieldName: 'amountInvestedWithGapRisk',
        variant: 'full'
      })(params)
    },
    cellStyle
  },
  {
    headerName: 'Delta One',
    field: 'amountInvestedWithoutGapRisk',
    minWidth: 190,
    flex: 0.1,
    cellRenderer: params => {
      if (params.context.viewAsValueOrPercentage === 'percentage') {
        if (params.value === Infinity) return 'No AUM available'
        return displayPercentage(params.value, 2)
      }
      return CurrencyCell({
        currencyFieldName: 'currency',
        fieldName: 'amountInvestedWithoutGapRisk',
        variant: 'full'
      })(params)
    },
    cellStyle
  },
  {
    headerName: 'Total',
    field: 'amountInvestedTotal',
    minWidth: 190,
    flex: 0.1,
    cellRenderer: params => {
      if (params.context.viewAsValueOrPercentage === 'percentage') {
        if (params.value === Infinity) return 'No AUM available'
        return displayPercentage(params.value, 2)
      }
      return CurrencyCell({
        currencyFieldName: 'currency',
        fieldName: 'amountInvestedTotal',
        variant: 'full'
      })(params)
    },
    cellStyle
  }
]

const DEFAULT_COLUMN_OPTIONS: ColDef = {
  sortable: true,
  unSortIcon: true
}

export interface AssetConcentrationTableProps {
  data: AssetConcentrationReportEntry[]
  viewAsValueOrPercentage: 'value' | 'percentage'
}

const AssetConcentrationTable = ({
  data,
  viewAsValueOrPercentage
}: AssetConcentrationTableProps) => (
  <Table
    agGridProps={{
      columnDefs: COLUMN_DEFS,
      defaultColDef: DEFAULT_COLUMN_OPTIONS,
      headerHeight: 60,
      rowData: data,
      rowHeight: 44,
      context: {
        viewAsValueOrPercentage
      }
    }}
    height="600px"
  />
)
export default AssetConcentrationTable
